import React from 'react';
import MessageContainer from './MessageContainer';
import { useLanguage } from '@/contexts';

interface NotFoundDisplayProps {
  onBack: () => void;
}

// Simple icon component for not found state
const NotFoundIcon: React.FC = () => (
  <div className="text-gray-400 mb-4">
    <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  </div>
);

// Simple message component
const NotFoundMessage: React.FC = () => {
  const { t } = useLanguage();
  return (
  <>
    <h2 className="text-xl font-semibold text-gray-900 mb-2">{t("promptNotFound")}</h2>
    <p className="text-gray-600 mb-4">{t("promptNotExist")}</p>
  </>
)};

// Simple action button component
const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useLanguage();
  return (
  <button
    onClick={onClick}
    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-dark-blue hover:bg-brand-electric-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-electric-blue"
  >
    {t("goBack")}
  </button>
)};

// Container component that composes the simple components
const NotFoundDisplay: React.FC<NotFoundDisplayProps> = ({ onBack }) => (
  <MessageContainer>
    <NotFoundIcon />
    <NotFoundMessage />
    <BackButton onClick={onBack} />
  </MessageContainer>
);

export default NotFoundDisplay;

// Export individual components for reuse
export { NotFoundIcon, NotFoundMessage, BackButton };
